import { NgModule } from '@angular/core';

import { RtUICommonModule } from '../common/common.module';
import { TourHighlightComponent } from './tour-highlight.component';
import { TourHighlightDirective } from './tour-highlight.directive';
import { TourHighlightService } from './tour-highlight.service';

@NgModule({
  imports: [RtUICommonModule, TourHighlightComponent, TourHighlightDirective],
  exports: [TourHighlightDirective, TourHighlightComponent],
})
export class RtUITourHighlightModule {}

export { TourHighlightService, TourHighlightDirective, TourHighlightComponent };
